<template>
  <router-link to="/carrinho" class="shopping-cart-link" v-if="$route.meta.showCartLink && cartCount > 0">
    <i class="fa fa-shopping-cart"></i>
    &nbsp;
    <span class="badge badge-dark">{{ cartCount }}</span>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      cartCount: 'getCartCount'
    })
  },
}
</script>
